import { theme } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'
export { buildModifiers } from './build-modifiers'

export type PopperRefHandler = (ref: HTMLElement | null) => void

export type Placement =
  | 'auto-start'
  | 'auto'
  | 'auto-end'
  | 'top-start'
  | 'top'
  | 'top-end'
  | 'right-start'
  | 'right'
  | 'right-end'
  | 'bottom-end'
  | 'bottom'
  | 'bottom-start'
  | 'left-end'
  | 'left'
  | 'left-start'

export const cssTransitionTimeouts = {
  exit: 25,
  enter: 300,
  appear: 300
}

export const transitionName = 'contrast-popper-transition'

export const fadeCss = css`
  display: block !important;
  z-index: ${theme.zIndex.popover};

  &.${transitionName}-enter {
    opacity: 0;
  }

  &.${transitionName}-enter-active {
    opacity: 1;
    transition: opacity ${cssTransitionTimeouts.enter}ms ease-in;
  }
  &.${transitionName}-exit {
    opacity: 1;
  }
  &.${transitionName}-exit-active {
    opacity: 0;
    transition: opacity ${cssTransitionTimeouts.exit}ms ease-out;
  }
`
